<template>
    <div class="text-start">
        <nav class="border-b border-gray-300 p-4">
            <div class="flex justify-between">
                <div class="">
                    <div class="text-xl font-bold text-primary">
                        New hotspot
                    </div>
                </div>
            </div>
        </nav>
        <div class="p-4">
            <div class="border p-4 rounded mt-4 overflow-auto">
                <UpdateOrCreateAccessPointComponent :venue-id="id" />
            </div>
        </div>
    </div>
</template>
<script>
import UpdateOrCreateAccessPointComponent from "../../components/UpdateOrCreateAccessPointComponent";

export default {
    name: "CreateAccesspoint",
    components: { UpdateOrCreateAccessPointComponent },
    data() {
        return {
            id: this.$route.params.id
        }
    },
    methods: {}
}
</script>
<style scoped>
</style>